// extracted by mini-css-extract-plugin
module.exports = {"supplierDetail":"JobOrderingTab_supplierDetail__rb5RC"};